import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import design from '@/config/design';
import { ButtonV2 as Button } from '@/components/Button';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L10 17.4142L6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929C6.68342 11.9024 7.31658 11.9024 7.70711 12.2929L10 14.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289Z",
      fill: "#12131A"
    })
  }));
};

CheckIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const ThemeOptions = _ref => {
  let {
    themes,
    activeThemeId,
    disabled,
    previews,
    onChange
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles.themes,
    children: themes.map(theme => {
      var _previews$theme$id;

      return /*#__PURE__*/_jsx(ThemeOption, _objectSpread({
        theme: theme,
        previewImg: (_previews$theme$id = previews[theme.id]) === null || _previews$theme$id === void 0 ? void 0 : _previews$theme$id.img,
        active: theme.id === activeThemeId,
        disabled: disabled,
        backgroundColor: theme.styles['body-background-color']
      }, !disabled && {
        onClick: () => onChange(theme)
      }), theme.id);
    })
  });
};

const ThemeOption = _ref2 => {
  let {
    theme,
    previewImg,
    active,
    disabled = false,
    backgroundColor = design.colors.white,
    onClick
  } = _ref2;
  const isDark = theme.tags.includes('dark');
  const label = `Use ${theme.name}` + (isDark ? ' (Dark)' : '');
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.theme, {
      [styles['theme--active']]: active,
      [styles['theme--disabled']]: disabled
    }),
    style: {
      backgroundColor
    },
    onClick: onClick,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.preview,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.previewImg,
        children: /*#__PURE__*/_jsx("img", {
          src: previewImg,
          alt: `${theme.name} theme preview`
        })
      }), active ? /*#__PURE__*/_jsx("div", {
        className: styles.activeIndicator,
        children: /*#__PURE__*/_jsx(CheckIcon, {})
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.themeFooter,
      children: /*#__PURE__*/_jsx(Button, {
        type: "button",
        size: "medium",
        variant: isDark ? 'white' : 'dark',
        className: styles.themeButton,
        children: label
      })
    })]
  });
};

export default ThemeOptions;